import { render, staticRenderFns } from "./ComboCodigo.vue?vue&type=template&id=059b2465&scoped=true"
import script from "./ComboCodigo.vue?vue&type=script&lang=js"
export * from "./ComboCodigo.vue?vue&type=script&lang=js"
import style0 from "./ComboCodigo.vue?vue&type=style&index=0&id=059b2465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b2465",
  null
  
)

export default component.exports